<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
          <div class="text-center">
            <h1 class="display-3 mr-4 text-nowrap">Welcome To </h1>
            <h3>AI Detection Admin</h3>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Welcome'
}
</script>
